export default __webpack_public_path__ + "static/feature2-7f6c25bf0f6b17e5e1258250d38c0e45.png";